/** Last merged catalog stats (dev / troubleshooting). */

export interface CatalogHealthSnapshot {
  updatedAt: number;
  shopIds: string[];
  productCountByShop: Record<string, number>;
  totalMerged: number;
}

let lastSnapshot: CatalogHealthSnapshot | null = null;

export function recordCatalogMerge(partial: {
  shopIds: string[];
  productCountByShop: Record<string, number>;
  totalMerged: number;
}): void {
  lastSnapshot = {
    updatedAt: Date.now(),
    ...partial,
  };
}

export function getCatalogHealthSnapshot(): CatalogHealthSnapshot | null {
  return lastSnapshot;
}
